<template>
  <div>
    <v-dialog v-model="show" :content-class="$vuetify.breakpoint.xsOnly ? '' : 'less-margin'"
              :fullscreen="$vuetify.breakpoint.xsOnly"
              :persistent="true"
              :scrollable="true" width="800px">
      <v-card>
        <v-card-title class="elevation-2 headline grey lighten-2"
                      style="margin-bottom: 2px; padding: 12px 8px 7px 16px; min-height: 69px">
            <div style="max-width: calc(100% - 60px)">{{merchant.name}}</div>
            <v-spacer/>
            <v-btn icon @click="$emit('on-close')" style="margin-bottom: 8px"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pa-0 ma-0" style="height: 100%; overscroll-behavior: none">
          <v-card-text class="py-2">
            <!-- Logo -->
            <div v-if="merchant.logo_display_link">
            <div class="pb-2; display: flex; justify-content: center;
            align-items: center; margin-bottom: 20px; center-all">
              <v-img
                  :src="merchant.logo_display_link"
                  max-width="200"
                  max-height="400"
                  class="mx-auto"
              />
            </div>

            <v-divider class="my-4" />
            </div>
            <!-- Info -->
            <p><strong>Description:</strong> {{ merchant.description }}</p>
            <p v-if="merchant.website">
              <strong>Website:</strong>
              <a :href="merchant.website" target="_blank">{{ merchant.website }}</a>
            </p>
            <p v-if="merchant.phone"><strong>Phone:</strong> {{ formatPhone(merchant.phone) }}</p>
            <p v-if="merchant.email"><strong>Email:</strong> {{ merchant.email }}</p>
            <div v-if="merchant.locations && merchant.locations.length">
              <p v-if="merchant.locations.length === 1">
                <strong>Location:</strong> {{ formatLocation(merchant.locations[0]) }}
              </p>
              <div v-else>
                <p><strong>Locations:</strong></p>
                <p v-for="(location, index) in merchant.locations" :key="index">
                  {{ formatLocation(location) }}
                </p>
              </div>
            </div>
          </v-card-text>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn color="red white--text" @click="removeDialog = true" :loading="loading">
            Remove Merchant
          </v-btn>
          <v-spacer />
          <v-btn outlined @click="$emit('on-close')">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeDialog" max-width="500" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="elevation-2 headline grey lighten-2"
                      style="margin-bottom: 2px; padding: 12px 8px 7px 16px; min-height: 69px">
          <div style="max-width: calc(100% - 60px)">Remove {{merchant.name}}</div>
          <v-spacer/>
          <v-btn icon @click="removeDialog = false" style="margin-bottom: 8px"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <p>The merchant will be removed, and the member will be notified with the reason you provide.</p>
          <v-textarea
              v-model="removalReason"
              label="Reason for removal"
              counter="75"
              maxLength="75"
              outlined
              required
          ></v-textarea>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pa-2">
          <v-btn color="red white--text" :loading="loading" @click="removeMerchant" :disabled="!removalReason">Confirm</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="removeDialog = false; removalReason = ''" :loading="loading">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorDialog ref="errorDialog"/>
  </div>
</template>


<script>
import ErrorDialog from "@/components/ErrorDialog.vue";

export default {
  name: "SelectedMerchant",
  components: {ErrorDialog},
  props: {
    merchant: {type: Object},
  },
  data() {
    return {
      loading: false,
      show: true,
      removeDialog: false,
      removalReason: '',
    }
  },
  methods: {
    async removeMerchant() {
      this.loading = true;

      if (this.removalReason.trim() !== '') {
        try {
          const data = {
            merchantUuid: this.merchant.uuid,
            removalReason: this.removalReason
          };
          await this.axios.delete('/admin/merchant', {
            params: data
          });
          this.removalReason = '';
          this.$emit('removed-successfully');
          this.removeDialog = false;

          this.$emit('on-close');
        } catch (e) {
          let errorInfo = '';
          if (e.response && e.response.data && e.response.data.message) {
            errorInfo = " " + e.response.data.message;
          }
          this.$refs.errorDialog.showError({
            errorMessage: "Failed to remove Merchant. " + errorInfo,
            forDevelopers: e
          });
        }
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    formatLocation(location) {
      const {street_1, street_2, city, state_region, postal_code, country} = location;
      let formattedLocation = '';

      if (street_1) {
        formattedLocation += street_1;
      }
      if (street_2) {
        formattedLocation += formattedLocation ? `, ${street_2}` : street_2;
      }

      formattedLocation += formattedLocation ? `, ${city}` : city;
      formattedLocation += `, ${state_region}, ${postal_code}, ${country}`;

      return formattedLocation;
    },

    formatPhone(phone) {
      const phoneLength = phone.length;
      if (phoneLength === 10) {
        // Format 10-digit phone number (US)
        return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
      } else if (phoneLength > 10 && phoneLength <= 15) {
        // Format phone number with country code
        const countryCode = phone.slice(0, phoneLength - 10);
        const localNumber = phone.slice(phoneLength - 10);
        return `+${countryCode} (${localNumber.slice(0, 3)}) ${localNumber.slice(3, 6)}-${localNumber.slice(6)}`;
      } else {
        // Return the phone as it is - shouldn't be any that hit this
        return phone;
      }
    },
  }
}
</script>